import React, { Fragment } from 'react';

import { GridRenderCellParams } from '@mui/x-data-grid';
import { Switch } from '@mui/material';

export const renderUserEnabled = (
  params: GridRenderCellParams<any, any, any>,
  onToggleUserStatus: (email: string, shouldEnable: boolean) => Promise<void>
) => {
  const email = params.row.email;

  const onChange = (e: any) => {
    const shouldEnable = e.target.checked;
    onToggleUserStatus(email, shouldEnable);
  };

  return <Fragment> <Switch checked={params.row.enabled} onChange={onChange}/> </Fragment>;
};
